export const PaymentOptions = Object.freeze({
  // These enum values map to reference data options in Kentico CMS
  PAY_NOW: 'Pay now',
  PAY_LATER: 'Pay later',
});

export default PaymentOptions;
